module.exports = __webpack_public_path__ + "16e36cf6ea2d8ceb01358f4dda79c6a8.svg";